import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@crunchyroll/cx-web-components";

import AccountRestrictedModal from "./AccountRestrictedModal";
import { useModal } from "../hooks";
import { VERIFY_EMAIL_MODAL_QUERY_PARAM } from "../constants";
import { useSendEmailVerification } from "../../user/emailVerification";

const EmailRestrictedModal = ({}) => {
  const { isOpen, closeModal } = useModal(VERIFY_EMAIL_MODAL_QUERY_PARAM);
  const sendVerifyEmail = useSendEmailVerification();
  const handleVerifyClick = useCallback(async () => {
    closeModal();
    await sendVerifyEmail();
  }, [sendVerifyEmail, closeModal]);

  return (
    <AccountRestrictedModal
      title={<FormattedMessage id="account_restricted.modal.email.title" />}
      description={
        <FormattedMessage id="account_restricted.modal.description" />
      }
      isOpen={isOpen}
      handleClose={closeModal}
      confirmBtn={
        <Button onClick={handleVerifyClick}>
          <FormattedMessage id="account_restricted.modal.email.verify_button" />
        </Button>
      }
    />
  );
};

export default EmailRestrictedModal;
